var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiftingPlatform = function SvgLiftingPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "liftingPlatform_svg__a",
    d: "M0 0h28.781v28.781H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "liftingPlatform_svg__c",
    d: "M0 0h38.257v38.931H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.596 4.645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "liftingPlatform_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#liftingPlatform_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.096 4.075a.021.021 0 0 0-.021.021v20.59c0 .01.01.02.021.02h20.59c.01 0 .02-.01.02-.02V4.095a.021.021 0 0 0-.02-.021H4.095zm20.59 24.706H4.095A4.101 4.101 0 0 1 0 24.685V4.096A4.101 4.101 0 0 1 4.096 0h20.59a4.101 4.101 0 0 1 4.095 4.096v20.59a4.101 4.101 0 0 1-4.096 4.095z",
    mask: "url(#liftingPlatform_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.42 4.635)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "liftingPlatform_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#liftingPlatform_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M38.257 30.811H11.11a5.795 5.795 0 0 0-2.99-2.99V6.957A6.769 6.769 0 0 0 1.165.003v4.636a2.133 2.133 0 0 1 2.318 2.318v20.864a5.795 5.795 0 1 0 7.627 7.626h27.146z",
    mask: "url(#liftingPlatform_svg__d)"
  })))));
};
export default SvgLiftingPlatform;